import React from "react";
export default (function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("div", { className: className }, children);
});
